import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404</h1>
            <p>Pagina non trovata. Riprovare ved</p>
        </div>
    );
};

export default NotFound;
